import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import duration from "dayjs/plugin/duration";
import 'dayjs/locale/de';
import { Pipe, type PipeTransform } from '@angular/core';

dayjs.extend(relativeTime);
dayjs.extend(duration);
dayjs.locale('de')

@Pipe({
    name: 'date_shared',
    standalone: false
})
export class DateSharedPipe implements PipeTransform {
  transform(date: Date | string | undefined | null, type: 'date' | 'datetime' | 'timeago' = 'datetime'): string {
    if (!date) {
      return '';
    }
    
    if (type === 'date') {
      return dayjs(date).format('DD.MM.YYYY');
    }
    
    if (type === 'timeago') {
      return dayjs(date).fromNow();
    }

    return dayjs(date).format('DD.MM.YYYY - HH:mm:ss');
  }
}

@Pipe({
    name: 'duration_shared',
    standalone: false
})
export class DurationSharedPipe implements PipeTransform {
  transform(duration: number): string {

    return dayjs.duration(duration * 1000)
      .format('H[h] m[m] s[s]')
      .replace(/^(0h 0m|0h)/, '')
      .trim();
  }
}
